// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Fjeu","title":"styles_title__2Iu6T","text":"styles_text__14Ezj"};